const search = new URLSearchParams(window.location.search);
export let BRO = search.get('bro') || 'Bro'; // other bro's be bro-ing different 🤔
